// tutorSaga.js
import { call, put, takeLatest } from "redux-saga/effects";

import {
  FETCH_TUTORS_REQUEST,
  ADD_TUTOR_REQUEST,
  UPDATE_TUTOR_REQUEST,
  DELETE_TUTOR_REQUEST,
} from "./actionTypes";

import {
  fetchTutorsSuccess,
  fetchTutorsFailure,
  addTutorSuccess,
  addTutorFailure,
  updateTutorSuccess,
  updateTutorFailure,
  deleteTutorSuccess,
  deleteTutorFailure,
} from "./actions";

import axiosInstance from "pages/Utility/axiosInstance";
import { showSuccess } from "helpers/notification_helper";

// ---------------- API calls ---------------- //
const fetchTutorsApi = async (params) => {
  return await axiosInstance.get("V1/tutors", { params });
};

const addTutorApi = async (tutor) => {
  return await axiosInstance.post("V1/tutors", tutor);
};

const updateTutorApi = async ({ id, tutor }) => {
  return await axiosInstance.put(`V1/tutors/${id}`, tutor);
};

const deleteTutorApi = async (tutorId) => {
  return await axiosInstance.delete(`V1/tutors/${tutorId}`);
};

// ---------------- Sagas ---------------- //

// Fetch tutors
function* fetchTutorsSaga(action) {
  try {
    const response = yield call(fetchTutorsApi, action.payload);
    yield put(fetchTutorsSuccess(response.data));
  } catch (error) {
    yield put(fetchTutorsFailure(error.message));
  }
}

// Add tutor
function* addTutorSaga(action) {
  try {
    const response = yield call(addTutorApi, action.payload.tutor);
    action.payload.onClose();
    yield put(addTutorSuccess(response.data));
    showSuccess("Tutor added successfully!");
  } catch (error) {
    yield put(addTutorFailure(error?.response?.data?.errors));
  }
}

// Update tutor
function* updateTutorSaga(action) {
  try {
    const response = yield call(updateTutorApi, action.payload);
    showSuccess(response?.data?.message);
    action.payload.onClose();
    yield put(updateTutorSuccess(response?.data));
  } catch (error) {
    yield put(updateTutorFailure(error?.response?.data?.errors));
  }
}

// Delete tutor
function* deleteTutorSaga(action) {
  try {
    const { data } = yield call(deleteTutorApi, action.payload);
    yield put(deleteTutorSuccess(data));
    showSuccess("Tutor deleted successfully!");
  } catch (error) {
    yield put(deleteTutorFailure(error.message));
  }
}

// ---------------- Watcher saga ---------------- //
export default function* tutorSaga() {
  yield takeLatest(FETCH_TUTORS_REQUEST, fetchTutorsSaga);
  yield takeLatest(ADD_TUTOR_REQUEST, addTutorSaga);
  yield takeLatest(UPDATE_TUTOR_REQUEST, updateTutorSaga);
  yield takeLatest(DELETE_TUTOR_REQUEST, deleteTutorSaga);
}
